import { DashboardPanel } from './DashboardPanel';

export function LegendPanel() {
  return (
    <DashboardPanel title="Legend">
      <p className="mt-2 flex justify-between text-[13px] text-softer">
        <span>GEX: Gamma Exposure</span>
      </p>
      <p className="mt-2 flex justify-between text-[13px] text-softer">
        <span>VEX: Volatility Exposure</span>
      </p>
    </DashboardPanel>
  );
}
